import React from "react";
import { Grid } from "@mui/material";

const TextAreaField = ({
  placeholder,
  value,
  maxLength,
  width,
  height,
  onChange,
  borderRadius,
  isNumber,
}) => {
  return (
    <Grid
      container
      lg={12}
      xs={12}
      md={12}
      className="input_bg"
      alignItems="center"
      justifyContent="flex-end"
    >
      <textarea
        className="Textarea"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        maxLength={maxLength ? maxLength : 1500}
        rows={4}
        style={{ height: height ? height : "20vh", width: width, borderRadius: borderRadius ? borderRadius : "8px" }}
      />
      {isNumber ? "" :
        <Grid
          container
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <p className="textBlack">
            <span className="textBlack"> {value?.length} </span> / {maxLength ? maxLength : 1500}
          </p>
        </Grid>
      }
    </Grid>
  );
};

export default TextAreaField;